import {
    FilterType,
} from 'app/enums/common.enums'
import SkyNetLink, {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'

import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    ContainersDamagedType,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.types'

export default ({
    getContainerLink,
    containerLinkClassName,
}: {
    getContainerLink: (serialNumber: string) => string,
    containerLinkClassName: string
}): SkyDataGridColumnDefinition<ContainersDamagedType>[] => {
    return [
        {
            name: 'serialNumber',
            renderCell: ({
                value,
            }) => {
                return (
                    <SkyNetLink
                        text={value}
                        type={TypeLink.EXTERNAL}
                        size={SizeLink.S}
                        link={getContainerLink(value)}
                        customClasses={{
                            wrapper: containerLinkClassName,
                        }}
                    />
                )
            },
            labelKey: 'SERIAL_NUMBER',
            width: 160,
        },
        {
            name: 'jypId',
            labelKey: 'JYP_NUMBER',
            width: 160,
        },

        {
            name: 'containerTypeContainerModel',
            filterField: 'containerTypeContainerModel',
            filterType: FilterType.Array,
            width: 250,
            labelKey: 'CONTAINER_MODEL',
        },
        {
            name: 'containerStatusEnriched',
            componentName: 'ContainerStatusEnriched',
            filterField: 'containerStatusEnriched',
            filterType: FilterType.Array,
            width: 200,
            labelKey: 'STATUS',
        },
        {
            name: 'damageTypes',
            componentName: 'List',
            labelKey: 'DAMAGES_TO_BE_FIXED',
        },
    ]
}
